import { useMemo, useCallback } from 'react'

import { unique } from 'utils/list'
import { generateSearchNeedle } from 'utils/search'

export function buildSearchStringMap(data, searchMapFn) {
  return data.reduce((searchStrings, attack) => {
    const terms = searchMapFn(attack)
    terms.forEach((term) => {
      if (searchStrings[term]) {
        if (!searchStrings[term].includes(attack)) {
          searchStrings[term].push(attack)
        }
      } else {
        searchStrings[term] = [attack]
      }
    })

    return searchStrings
  }, {})
}

export const search = (term, objects, searchStringMap) => {
  if (term.length) {
    const needle = term.toLowerCase()
    const haystack = searchStringMap

    const found = Object.keys(haystack).reduce((accum, key) => {
      if (key.toLowerCase().includes(needle)) {
        Array.prototype.push.apply(accum, haystack[key])
      }
      return accum
    }, [])

    return unique(found)
  }

  return objects
}

export default function useSearch(
  data = [],
  searchMapFn = (o) => generateSearchNeedle(o)
) {
  const searchStringMap = useMemo(
    () => buildSearchStringMap(data, searchMapFn),
    [data, searchMapFn]
  )

  const searchFn = useCallback(
    (term) => search(term.trim().toLowerCase(), data, searchStringMap),
    [data, searchStringMap]
  )

  return searchFn
}
